(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const printUrlSessionKey = 'printUrl';

  const sanitize = (value) => {
    if (!value || typeof value !== 'string') {
      return null;
    }

    const trimmed = value.trim();
    if (!trimmed || trimmed.toLowerCase().startsWith('javascript:')) {
      return null;
    }

    return trimmed;
  };

  const persistPrintUrl = (value) => {
    if (!value) {
      return;
    }

    try {
      window.localStorage?.setItem(printUrlSessionKey, value);
    } catch (error) {
      console.warn('printUrl: unable to persist preview URL', error);
    }

    window.__fabricPrintUrl = value;
  };

  const readStoredPrintUrl = () => {
    if (typeof window.__fabricPrintUrl === 'string') {
      const existing = sanitize(window.__fabricPrintUrl);
      if (existing) {
        return existing;
      }
    }

    try {
      return sanitize(window.localStorage?.getItem(printUrlSessionKey));
    } catch (error) {
      console.warn('printUrl: unable to read preview URL', error);
    }

    return null;
  };

  const handleReady = () => {
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    const paramValue = sanitize(url.searchParams.get('printUrl'));
    if (paramValue) {
      persistPrintUrl(paramValue);
    }

    const activePrintUrl = paramValue || readStoredPrintUrl();
    const section = document.querySelector('[data-print-section]');
    const imageContainer = document.querySelector('[data-print-preview-container]');
    const image = imageContainer.querySelector('[data-print-preview]');

    if (!activePrintUrl) {
      section.classList.add('collection-print-section--hidden');
      return;
    }

    image.onload = () => {
      imageContainer.classList.add('collection-print-preview--loaded');
    };
    image.src = activePrintUrl;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleReady, { once: true });
  } else {
    handleReady();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const printUrlSessionKey = 'printUrl';
  const printOverlayConfig = window.printOverlayConfig;

  const sanitizePrintUrl = (value) => {
    if (!value || typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed || trimmed.toLowerCase().startsWith('javascript:')) return null;
    return trimmed;
  };

  const clamp = (value, min, max) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return null;
    return Math.min(Math.max(value, min), max);
  };

  const updateLineItemProperty = (value) => {
    document.querySelectorAll('[data-lightbooth-print-property]').forEach((input) => {
      if (!value) {
        input.value = '';
        input.disabled = true;
      } else {
        input.value = value;
        input.disabled = false;
      }
    });
  };

  const readPrintPreviewUrl = () => {
    const fromGlobal = sanitizePrintUrl(window.__fabricPrintUrl);
    if (fromGlobal) return fromGlobal;
    try {
      return sanitizePrintUrl(window.localStorage?.getItem(printUrlSessionKey));
    } catch (error) {
      return null;
    }
  };

  const generateSrcset = (baseUrl) => {
    const widths = [240, 352, 832, 1200, 1600, 1920, 2560, 3840];
    const url = new URL(baseUrl);
    return widths.map((w) => {
      url.searchParams.set('width', w);
      return url.toString() + ' ' + w + 'w';
    }).join(', ');
  };

  const applyPrintImagePosition = (printImgContainer, imageUrl) => {
    if (!printImgContainer) return;

    const imgElement = printImgContainer.querySelector('[data-lightbooth-print-img-image]');
    if (!imgElement) return;

    imgElement.src = imageUrl;

    // Apply positioning from config
    const config = printOverlayConfig?.mediaIds?.[0];
    const width = config ? clamp(Number(config.w), 0, 1) : 0.3;
    const x = config ? clamp(Number(config.x), 0, 1) : 0.5;
    const y = config ? clamp(Number(config.y), 0, 1) : 0.5;
    const r = config?.r;

    if (width) printImgContainer.style.width = width * 100 + '%';
    if (x) printImgContainer.style.left = x * 100 + '%';
    if (y) printImgContainer.style.top = y * 100 + '%';
    if (r != null) {
      printImgContainer.style.transform = 'translate(-50%, -50%) rotate(' + Number(r) + 'deg)';
    }
  };

  const mountPrintPreview = (printUrl) => {
    const container = document.querySelector('[data-lightbooth-preview]');
    const image = container?.querySelector('[data-lightbooth-preview-image]');
    if (!container || !image || !printUrl) return;

    image.src = printUrl;
    container.classList.add('lightbooth-print-preview--visible');
  };

  const initLightboothPreview = () => {
    const printUrl = readPrintPreviewUrl();
    // console.log('[Lightbooth] printUrl:', printUrl ? printUrl.substring(0, 50) + '...' : null);
    // console.log('[Lightbooth] printOverlayConfig:', printOverlayConfig);

    updateLineItemProperty(printUrl);
    mountPrintPreview(printUrl);

    // If no printUrl or no transparentImage config, skip image overlay composition
    if (!printUrl || !printOverlayConfig?.transparentImage) {
      return;
    }

    const transparentImageUrl = printOverlayConfig.transparentImage;

    // Apply composition to all product media
    document.querySelectorAll('.product-media').forEach((container) => {
      // Swap product image src to transparent template
      const productImg = container.querySelector('.product-media__image');
      if (productImg) {
        productImg.src = transparentImageUrl;
        productImg.srcset = generateSrcset(transparentImageUrl);
      }

      // Set print image src and position
      const printImgContainer = container.querySelector('[data-lightbooth-print-img]');
      applyPrintImagePosition(printImgContainer, printUrl);

      // Activate composition styling
      if (printOverlayConfig.bg) {
        container.style.setProperty('--lightbooth-bg', printOverlayConfig.bg);
      }
      if (printOverlayConfig.radius) {
        container.style.setProperty('--lightbooth-radius', printOverlayConfig.radius);
      }
      container.classList.add('lightbooth-active');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightboothPreview, { once: true });
  } else {
    initLightboothPreview();
  }

  } catch(e) { console.error(e); }
})();
})();
